<template>
    <button
        :disabled="disabled"
        class="button-square"
        :class="classModificator ? `button-square_${classModificator}` : ''">
        <svg-icon
            v-if="!hideIcon"
            class="button-square__icon"
            :name="icon"/>
        <slot ></slot>

    </button>

</template>

<script>
export default {
    name: 'ButtonSquare',
    props: {
        icon: {
            type: String,
            default: ''
        },
        hideIcon: {
            type: Boolean,
            default: false
        },
        classModificator: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="less">
.button-square {
    --size: rem(40);

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: @color-white;
    border: rem(1) solid @color-gray-white;
    border-radius: rem(3);
    outline: none;

    padding: 0;

    height: var(--size);
    width: var(--size);

    transition-duration: .15s;
    transition-property: opacity, border-color, color;
    transition-timing-function: ease;

    &:not([disabled]) {
        .hover({
            border-color: @color-primary;
            color: @color-primary;
        });
    }

    &__icon {
        height: 50%;
        width: 50%;

        pointer-events: none;

        @{mobile} & {
            padding: rem(0.5);
        }
    }

    &[disabled] {
        opacity: .5;
    }

    &_with-loading{
        &:after{
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            margin-top: -15px/2;
            margin-left: -15px/2;
            left: 50%;
            width: 15px;
            height: 15px;
            background: url('~static/img/loading-sm.gif') no-repeat 50%;
            visibility: hidden;
            pointer-events: none;
            opacity: 0;
            .animate(opacity);
        }
    }

    &[data-loading="true"],
    &[data-loading="1"] {
        .button-square__icon{
            opacity: 0;
        }
        &:after{
            visibility: visible;
            opacity: 1;
        }
    }

    &_small {
        --size: rem(24);
        border: none;

        .button-square__icon {
            height: 100%;
            width: 100%;
        }
    }
}
</style>
